<ng-container *ngIf="enableMultiCity && flights$ | async as flights" data-testid="multicity-selector-new">
  <ng-container *ngFor="let flight of flights; index as i; first as first; last as last; trackBy: locationsHaveChanged">
    <div class="flex flex--space-between flex--middle ms-xsmall-b">
      <h2 class="font-body-1" [class.ms-xsmall-y]="i < 2">
        {{ 'bookingSearch.boundSelection.flightTitle' | finLocalization: { index: i + 1 } }}
      </h2>
      <fcom-icon-button
        *ngIf="i >= 2"
        class="flex flex--center flex--self-center location-switch"
        [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
        [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
        [size]="IconButtonSize.MEDIUM"
        [aria]="{ label: 'bookingSearch.boundSelection.removeFlight' | finLocalization: { index: i + 1 } }"
        (clickBtn)="removeFlight(i)"
        data-testid="remove-flight-button"
      />
    </div>
    <div class="grid-col-12 no-gutters selector-grid" [class.ms-small-b]="!last">
      <fin-location-selector
        [locationPair$]="flight | finToObservable"
        [showPreviousSearches]="enableMultiCity"
        [showSeparator]="true"
        [showLocateMe]="first"
        [showSuggestedDestinations]="first"
        (setLocations)="setLocations($event, i)"
        [attr.data-testid]="'booking-widget-full-multicity-location-selector-' + i"
      />
      <fin-travel-dates-selector
        [previousFlightDepartureDate$]="flights[i - 1]?.departureDate || null | finToObservable"
        [travelDates$]="
          {
            departureDate: flight.departureDate,
            returnDate: null,
          } | finToObservable
        "
        [priceCalendarType]="PriceCalendarType.ONLY_DATES"
        [locations$]="
          {
            origin: flight.origin,
            destination: flight.destination,
          } | finToObservable
        "
        [showSingular]="'departureDate'"
        [showSeparator]="false"
        [showAddReturn]="false"
        [tripType$]="TripType.ONEWAY | finToObservable"
        [showFlexibleDatesSelection]="false"
        [showPerAdultPrice]="false"
        (setTravelDates)="setTravelDates($event, i, false, enableMultiCity)"
        [attr.data-testid]="'booking-widget-multicity-dates-selector-' + i"
      />
    </div>
  </ng-container>
  <fcom-button
    *ngIf="flights$ | async as flights"
    class="ms-medium-y"
    [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
    [text]="'bookingSearch.boundSelection.addFlightButton' | finLocalization"
    [disabled]="flights.length === 6"
    (clickBtn)="addFlight(flights.length)"
    data-testid="add-flight-button"
  />
</ng-container>

<ng-container *ngIf="!enableMultiCity && flights$ | async as flights" data-testid="multicity-selector-old">
  <ng-container *ngFor="let flight of flights; index as i; first as first; last as last; trackBy: locationsHaveChanged">
    <h2 class="font-body-1 col-f">
      {{ 'bookingSearch.' + (first ? 'departure' : 'return') | finLocalization }}
    </h2>
    <div class="grid-col-12 no-gutters selector-grid" [class.ms-small-b]="!last">
      <fin-location-selector
        [locationPair$]="flight | finToObservable"
        [originDisabled]="!first && flights[i - 1].destination === undefined"
        [destinationDisabled]="last && flights[0].origin === undefined"
        [allowedOriginContinent]="!first ? flights[i - 1]?.destination?.continentCode : undefined"
        [allowedDestinationContinent]="last ? flights[0]?.origin?.continentCode : undefined"
        [showSeparator]="false"
        [showSuggestedDestinations]="first"
        (setLocations)="setLocations($event, i)"
        data-testid="booking-widget-multicity-location-selector"
      />
      <fin-travel-dates-selector
        [travelDates$]="
          {
            departureDate: flights[0].departureDate,
            returnDate: flights[1].departureDate,
          } | finToObservable
        "
        [priceCalendarType]="PriceCalendarType.ONLY_DATES"
        [locations$]="
          {
            origin: flight.origin,
            destination: flight.destination,
          } | finToObservable
        "
        [tripType$]="TripType.ONEWAY | finToObservable"
        [showSingular]="first ? 'departureDate' : 'returnDate'"
        [showSeparator]="false"
        [showAddReturn]="false"
        (setTravelDates)="setTravelDates($event, i, false, enableMultiCity)"
        (setFlexibleDates)="setFlexibleDates($event)"
        data-testid="booking-widget-multicity-dates-selector"
      />
    </div>
  </ng-container>
</ng-container>
